import React from 'react'
import { Link as GatsbyLink } from 'gatsby'
import { Row, Col } from 'react-bootstrap'
import { Article } from '../../types/tree'

const ProductArticleList = ({ articles }: { articles: Article[] }) => {
  return (
    <Row className={'mb-4'}>
      {
        articles.map(article => {
          const { title, _slug } = article
          return (
            <Col
              key={`article-${title}`}
              xl={12}
            >
              <GatsbyLink
                className='d-inline-block text-black'
                to={_slug}
              >
                {title}
              </GatsbyLink>
            </Col>

          )
        })
      }
    </Row>
  )
}
export default ProductArticleList
